import { render } from "./InfoCliente.vue?vue&type=template&id=5f7656aa&ts=true"
import script from "./InfoCliente.vue?vue&type=script&lang=ts"
export * from "./InfoCliente.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\agentcloudALProd\\_work\\12\\s\\AEL.NominaElectronica.Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__